import { useMutation, UseMutationOptions, UseMutationResult, useQuery, UseQueryResult } from "react-query";
import { request, gql, ClientError, GraphQLClient } from "graphql-request";
import { apiBaseUrl, graphQLClient, __DEV__ } from "../api";
import moment from "moment";
export interface ProductParams {
  country?: string;
  language?: string;
  currency?: string;
  limit?: number;
}
export function useProducts(
  params?: ProductParams,
  onSuccessCustom?: (data: [GQL.V2Product]) => void
): UseQueryResult<[GQL.V2Product], ClientError> {
  const { country, language, currency, limit = 500 } = params || {};
  return useQuery(
    ["v2Products", country, language, currency, limit],
    async () => {
      const { v2Products: data } = await graphQLClient.request(
        gql`
          query v2Products($country: String, $language: String, $currency: String, $limit: Int) {
            v2Products(country: $country, language: $language, currency: $currency, limit: $limit) {
              productId
              name
              prodSku
              prodBarcode
              image
              tags
              translations {
                description
              }
              prices {
                priceAmountPayNowCurrent
                priceAmountPayNowCrossed
                priceAmountPayAfterTrialCurrent
                priceAmountPayAfterTrialCrossed
                recurringInterval
                recurringIntervalCount
                recurringTrialPeriodDays
                productSku
              }
            }
          }
        `,
        { limit }
      );
      if (__DEV__) {
        console.log(data);
      }
      return data;
    },
    {
      onSuccess: (data: any) => {
        if (onSuccessCustom !== undefined) onSuccessCustom!(data);
      },

      // Don't refetch when window gets focus if we already have data
      refetchOnWindowFocus: false,
      // Keep previous data while fetching new data
      keepPreviousData: true,
    }
  );
}
